import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

import { CONSENT_KEY as COOKIE_CONSENT_KEY, loadTrackingScripts } from "@/lib/analytics";

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  // Demo visits load no tracking at all (see analytics.ts), so there's nothing to ask consent for.
  const onDemo = useLocation().pathname === "/demo";

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay to avoid layout shift on initial load
      const timer = setTimeout(() => setShowBanner(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    loadTrackingScripts();
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setShowBanner(false);
  };

  if (!showBanner || onDemo) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-5 duration-300">
      <div className="mx-auto max-w-4xl rounded-lg border bg-background p-4 shadow-lg md:p-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex-1 pr-8">
            <h3 className="font-semibold text-foreground mb-1">We value your privacy</h3>
            <p className="text-sm text-muted-foreground">
              With your permission, we use Google Ads cookies to measure our advertising and business sign-ups.{" "}
              By clicking "Accept All", you consent to our use of cookies.{" "}
              <a href="/privacy" className="text-primary hover:underline">
                Learn more about our Privacy Policy
              </a>
            </p>
          </div>
          <div className="flex flex-shrink-0 gap-2">
            <Button variant="outline" size="sm" onClick={declineCookies}>
              Decline
            </Button>
            <Button size="sm" onClick={acceptCookies}>
              Accept All
            </Button>
          </div>
        </div>
        <button
          onClick={declineCookies}
          className="absolute right-2 top-2 rounded-sm p-1 text-muted-foreground opacity-70 hover:opacity-100 transition-opacity md:hidden"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
